import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable, { createTheme } from 'react-data-table-component';
import dateFormat from "dateformat";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AdminLayout from '../layout/AdminLayout';
import { apiError } from '../../helpers/ErrorHelper';
import { get, put, post, setAuthToken, del } from '../../config/ApiConfig';
import { tableCustomLoader } from '../../helpers/StyleHelper';
import { useAuth } from '../../context/AuthContext';
import { invoiceAmount, invoiceStatus, prettyAmount } from '../../helpers/InvoiceHelper';
import { useTheme } from '../../context/ThemeContext';
import { getInvoiceMonthWiseChart, getInvoices, getInvoiceStats } from '../../models/InvoiceModel';
import { getCreditNotes, getCreditNoteStats } from '../../models/CreditNoteModel';
import InvoiceTables from '../tables/InvoiceTables';
import CreditNoteTables from '../tables/CreditNoteTables';
import CreateInvoiceModal from '../modals/Invoice/CreateInvoiceModal';
import DeleteInvoiceModal from '../modals/Invoice/DeleteInvoiceModal';
import CreateCreditNoteModal from '../modals/Invoice/CreateCreditNoteModal';
import DeleteCreditNoteModal from '../modals/Invoice/DeleteCreditNoteModal';
import { useNotificationCount } from '../../context/NotificationCountContext';
import { checkPermission } from '../../helpers/GeneralHelper';
import Error403 from './Error403';
import { formatMonthYear } from '../../helpers/DateHelper';
import { getFinancialYears, getCurrentFinancialYear, saveCurrentFinancialYearToStorage } from '../../models/MasterModel';
import { getData } from '../../models/ClientsModel';
import { Bar } from 'react-chartjs-2';
import { decryptData } from "../../helpers/EncryptHelper";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function Invoices() {

  const { notificationCount, setNotificationCount } = useNotificationCount();  

  const { theme, toggleTheme } = useTheme();  

  const { state } = useAuth(); 

  let user_data = state.user_data;
  
  const navigate = useNavigate();  
  
  const loader = document.getElementById('loading'); 

    const [modalKey, setModalKey] = useState(0);
    const [listTab, setListTab] = useState('invoices');

    //Add Invoice Start
    const [showAddInvoiceModal, setShowAddInvoiceModal] = useState(false);
    const [showAddCreditNoteModal, setShowAddCreditNoteModal] = useState(false);
    const [credit_note_row, setCreditNoteRow] = useState({});
    const [showDeleteCreditNoteModal, setShowDeleteCreditNoteModal] = useState(false);

    const openDeleteCreditNoteModal = (row) => {
        setCreditNoteRow(row);
        setModalKey((k) => k + 1);
        setShowDeleteCreditNoteModal(true);
    };
  //Add Invoice End


  //Delete Invoice Start
  const [invoice_data, setInvoiceData] = useState({});

  const [showDeleteInvoiceModal, setShowDeleteInvoiceModal] = useState(false);

  const [curr_fin_year_id, setCurrFinYearID] = useState(localStorage.getItem("current_fin_year") ? decryptData(localStorage.getItem("current_fin_year"))._fin_year_id : 0);
  const [curr_client_id, setCurrClientID] = useState('');
  const [clients, setClients] = useState([]);

    const fetchCurrentFinYear = async() => {
        try{
            const fin_resp = getCurrentFinancialYear();
            //console.log('fin_resp => ',fin_resp);
            if(fin_resp!=0){
                //console.log('fin_resp._fin_year_id => ', fin_resp._fin_year_id);
                //console.log('cur fin id ', curr_fin_year_id);
                setCurrFinYearID(fin_resp._fin_year_id);
                //console.log('cur fin id 2', curr_fin_year_id);
            }
        }catch(error){
            console.log(error);
        }
    }

    const fetchFinancialYears = async() => {
        setStatLoading(true);
        try {
            const resp = await getFinancialYears();
            setFinancialYears(resp.financial_years);
            console.log('financial years => ',resp.financial_years)//financialYears);
            //console.log('financial years2 => ',financialYears);
        }catch(error){
            console.log(error);
        }
    }

    const fetchClients = async() => {
        try {
            const response = await getData({user_token: user_data.user_token, page: 1, limit: 1000});
            //console.log('clients response => ', response);
            if (response.clients ) {
                //console.log('clients => ', response.clients);
                //return response.clients;
                setClients(response.clients);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            apiError(error);
            if (error.response?.data.invalid_token === 1) {
                navigate('/re-login');
            }
        }
    }

    const openDeleteInvoiceModal = (invoice_data) =>{
        setInvoiceData(invoice_data);
        setModalKey(prevKey => prevKey + 1); 
        setShowDeleteInvoiceModal(true);
    }
    //Delete Invoice End
  
    //Invoice List Start
    const [data, setData] = useState([]);
    const [cacheTime, setCacheTime] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [financialYears, setFinancialYears] = useState([]);

    const fetchInvoices = useCallback(async (newLimit, pageArg, clientId = curr_client_id) => {
        setLoading(true);
        try {
            let apiParam = {page: pageArg, limit: newLimit, user_token: user_data.user_token, _client_id : clientId};
            const response = await getInvoices(apiParam);
            if (typeof response != typeof undefined) {
                setData(response.invoices);
                setTotalRows(response.pagination.total_rows);
                setLimit(newLimit);
                setPage(pageArg);
                if (response.time) {
                    setCacheTime(response.time);
                }
                setNotificationCount(localStorage.getItem('unread_notification_count'));
            }
            setLoading(false);
        } catch (error) {
            //console.error(error);
        }
    }, [curr_client_id, user_data.user_token, setNotificationCount]);
    //Invoice List End

    const [creditNoteData, setCreditNoteData] = useState([]);
    const [creditNoteLoading, setCreditNoteLoading] = useState(true);
    const [creditNoteTotalRows, setCreditNoteTotalRows] = useState(0);
    const [creditNotePage, setCreditNotePage] = useState(1);
    const [creditNoteLimit, setCreditNoteLimit] = useState(10);

    const fetchCreditNotes = useCallback(async (newLimit, pageArg, clientId = curr_client_id) => {
        setCreditNoteLoading(true);
        try {
            const listParams = { page: pageArg, limit: newLimit };
            if (clientId) {
                listParams._client_id = clientId;
            }
            const response = await getCreditNotes(user_data.user_token, listParams);
            if (response) {
                setCreditNoteData(response.credit_notes || []);
                setCreditNoteTotalRows(response.pagination?.total_rows || 0);
                setCreditNoteLimit(newLimit);
                setCreditNotePage(pageArg);
                setNotificationCount(localStorage.getItem('unread_notification_count'));
            }
            setCreditNoteLoading(false);
        } catch (error) {
            setCreditNoteLoading(false);
        }
    }, [curr_client_id, user_data.user_token, setNotificationCount]);

    //Flush Invoice Start
    const flushInvoice = (clientId = curr_client_id) => {
        localStorage.removeItem("invoices");
        fetchInvoices(limit, page, clientId);
    };
    //Flush Invoice End

    //Invoice / credit note stats
    const [stats, setStats] = useState([]);
    const [creditNoteStats, setCreditNoteStats] = useState({});
    const [statLoading, setStatLoading] = useState(true);

    const fetchInvoiceStats = async () => {
        setStatLoading(true);
        try {
            const response = await getInvoiceStats(user_data.user_token);
            if (response.status && response.data?.invoice_stats) {
                setStats(response.data.invoice_stats);
            } else if (!response.status) {
                navigate('/re-login');
            }
        } catch (error) {
            // ignore
        } finally {
            setStatLoading(false);
        }
    };

    const fetchCreditNoteStats = async () => {
        setStatLoading(true);
        try {
            const response = await getCreditNoteStats(user_data.user_token);
            if (response?.status && response.data?.credit_note_stats) {
                setCreditNoteStats(response.data.credit_note_stats);
            } else if (response && !response.status) {
                navigate('/re-login');
            }
        } catch (error) {
            // ignore
        } finally {
            setStatLoading(false);
        }
    };

    useEffect(() => {
        if (listTab === 'credit_notes') {
            fetchCreditNoteStats();
        } else {
            fetchInvoiceStats();
        }
    }, [listTab]);


  //Invoice Month Wise Chart Start
    const options = {
        scales: {
            x: {
                type: 'category', // Define the x-axis as categorical
            },
        },
        maintainAspectRatio: false
    };

    const [chart, setChart] = useState({
        labels: [],
        datasets: [
            {
                label: 'Invoice Amount',
                data: [],
                backgroundColor: '#5f76e8',
                tension: 0.1,
            }
        ],
    });
    const [chartLoading, setChartLoading] = useState(true);

    const fetchInvoiceChart = async()=>{
        setChartLoading(true);
        try {
            const response = await getInvoiceMonthWiseChart(user_data.user_token);
            if (response.status) {
                if (response.data.invoice_month_wise_data) {
                    const chartData = {
                        labels: response.data.invoice_month_wise_data.map(item => {
                            const [year, month] = item.month.split('-');
                            const dateString = month+'-'+year;
                            return `${formatMonthYear(dateString)}`;
                        }),
                        datasets: [
                            {
                                label: 'Invoice Amount',
                                data: response.data.invoice_month_wise_data.map(item => (parseInt(item.invoice_amount))),
                                backgroundColor: '#5f76e8',
                                tension: 0.1,
                            }
                        ],
                    };
                    setChart(chartData);
                    setChartLoading(false);
                }
            }
        } catch (error) {
            //console.error(error);
        }
    }
  //Invoice Month Wise Chart End

    useEffect(() => {
        //fetchCurrentFinYear();
        fetchFinancialYears();
        fetchInvoiceChart();
        fetchClients();
    }, []); 

    const handleYearChange = async(e) => {
        const selectedId = e.target.value;
        setCurrFinYearID(selectedId);
        //console.log('curr finan year =>  ', selectedId);
        const selectedYearObj = financialYears.find(
            (year) => year._fin_year_id.toString() === selectedId
        );
    
        if (selectedYearObj) {
            // console.log("Selected Year ID:", selectedId);
            // console.log("Selected Year Label:", selectedYearObj.fin_year);
            saveCurrentFinancialYearToStorage(selectedId,selectedYearObj.fin_year)
            fetchInvoiceChart();
            if (listTab === 'credit_notes') {
                fetchCreditNoteStats();
            } else {
                fetchInvoiceStats();
            }
            flushInvoice();
        }
    };

    const handleClientChange = async(e) => {
        const selectedId = e.target.value;
        localStorage.removeItem("invoices");
        setCurrClientID(selectedId);
        setPage(1);
    }

  return (
    <>
        {checkPermission('invoices')===true ? (
        <AdminLayout>
            <Helmet>
                <title>Invoices - Ancile Digital</title>
            </Helmet>
            <div className="main-content app-content">
                <div className="container-fluid">
                    {/* <!-- Page Header --> */}
                    <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                        <h1 className="page-title fw-semibold fs-18 mb-0">
                            {listTab === 'invoices' ? 'Invoice List' : 'Credit notes'}
                        </h1>
                        <div className="ms-md-1 ms-0">
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><a href="javascript:void(0);">Invoice</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Invoice List</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/* <!-- Page Header Close --> */}
                    {/* <!-- Start::row-1 --> */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card custom-card">
                                <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3 py-3">
                                    <div className="d-flex flex-wrap align-items-center gap-2 gap-lg-3 flex-grow-1">
                                        <span className="text-muted fs-12 text-nowrap align-self-center">
                                            Last Synced On {cacheTime}
                                        </span>
                                        <select
                                            id="financial_year"
                                            className="form-control form-control-sm"
                                            style={{ minWidth: "150px", maxWidth: "220px" }}
                                            value={curr_fin_year_id}
                                            onChange={handleYearChange}
                                        >
                                            <option value="" hidden>Select Financial Year</option>
                                            {financialYears.map((year) => (
                                                <option key={year._fin_year_id} value={year._fin_year_id}>
                                                    {year.fin_year}
                                                </option>
                                            ))}
                                        </select>
                                        <select
                                            id="client_id"
                                            className="form-control form-control-sm"
                                            style={{ minWidth: "180px", maxWidth: "min(340px, 100vw)" }}
                                            value={curr_client_id}
                                            onChange={handleClientChange}
                                        >
                                            <option value="">Select Client</option>
                                            {clients.map((client) => (
                                                <option key={client._client_id} value={client._client_id}>
                                                    {client.client_name + "(" + client.client_gstin + ")"}
                                                </option>
                                            ))}
                                        </select>
                                        <ul className="nav nav-pills nav-sm mb-0 me-2">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${listTab === 'invoices' ? 'active' : ''}`}
                                                    onClick={() => setListTab('invoices')}
                                                >
                                                    Invoices
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${listTab === 'credit_notes' ? 'active' : ''}`}
                                                    onClick={() => setListTab('credit_notes')}
                                                >
                                                    Credit notes
                                                </button>
                                            </li>
                                        </ul>
                                        <div className="d-flex flex-wrap align-items-center gap-2">
                                            {listTab === 'invoices' && (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                onClick={() => setShowAddInvoiceModal(true)}
                                                style={{ minHeight: "31px" }}
                                            >
                                                <i className="ri-add-line me-1 fw-semibold align-middle"></i> New Invoice
                                            </button>
                                            )}
                                            {listTab === 'credit_notes' && (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                onClick={() => setShowAddCreditNoteModal(true)}
                                                style={{ minHeight: "31px" }}
                                            >
                                                <i className="ri-add-line me-1 fw-semibold align-middle"></i> New credit note
                                            </button>
                                            )}
                                            <button
                                                type="button"
                                                className="btn btn-success-light btn-sm"
                                                onClick={() => {
                                                    if (listTab === 'invoices') {
                                                        flushInvoice();
                                                    } else {
                                                        fetchCreditNotes(creditNoteLimit, creditNotePage, curr_client_id);
                                                        fetchCreditNoteStats();
                                                    }
                                                }}
                                                style={{ minHeight: "31px" }}
                                            >
                                                <i className="ri-refresh-line me-1 fw-semibold align-middle"></i> Refresh
                                            </button>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center flex-shrink-0 ms-xl-auto">
                                        {statLoading ? (
                                            <div className="d-flex align-items-center py-1 px-2">
                                                <span className="loader-new" aria-label="Loading totals" />
                                            </div>
                                        ) : (
                                            <div className="d-flex align-items-center gap-2 gap-md-3 ps-3 border-start border-secondary border-opacity-25">
                                                <div className="svg-icon-background bg-primary-transparent d-none d-md-flex">
                                                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" className="svg-primary" width="22" height="22"><path d="M13,16H7a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2ZM9,10h2a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Zm12,2H18V3a1,1,0,0,0-.5-.87,1,1,0,0,0-1,0l-3,1.72-3-1.72a1,1,0,0,0-1,0l-3,1.72-3-1.72a1,1,0,0,0-1,0A1,1,0,0,0,2,3V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V13A1,1,0,0,0,21,12ZM5,20a1,1,0,0,1-1-1V4.73L6,5.87a1.08,1.08,0,0,0,1,0l3-1.72,3,1.72a1.08,1.08,0,0,0,1,0l2-1.14V19a3,3,0,0,0,.18,1Zm15-1a1,1,0,0,1-2,0V14h2Zm-7-7H7a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"></path></svg>
                                                </div>
                                                <div className="text-end text-md-start">
                                                    <h6 className="mb-1 fs-11 text-muted text-uppercase text-nowrap">
                                                        {listTab === 'credit_notes'
                                                            ? 'Total credit notes amount (domestic)'
                                                            : 'Total Invoices Amount Domestic'}
                                                    </h6>
                                                    <div className="d-flex align-items-center justify-content-end justify-content-md-start gap-2 flex-wrap">
                                                        <h4 className="fs-18 fw-semibold mb-0 text-nowrap">
                                                            {prettyAmount(
                                                                "₹",
                                                                listTab === 'credit_notes'
                                                                    ? (creditNoteStats?.total_credit_note_amount_domestic ?? 0)
                                                                    : (stats?.total_invoice_amount_domestic ?? 0)
                                                            )}
                                                        </h4>
                                                        <span className="badge bg-primary fw-semibold">
                                                            {listTab === 'credit_notes'
                                                                ? (creditNoteStats?.total_credit_note_count_domestic ?? 0)
                                                                : (stats?.total_invoice_count_domestic ?? 0)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        {listTab === 'invoices' ? (
                                        <InvoiceTables 
                                          data={data}
                                          setData={setData}
                                          loading={loading}
                                          setLoading={setLoading}
                                          totalRows={totalRows}
                                          setTotalRows={setTotalRows}
                                          page={page}
                                          setPage={setPage}
                                          limit={limit}
                                          setLimit={setLimit}
                                          fetchInvoices={fetchInvoices}
                                          openDeleteInvoiceModal={openDeleteInvoiceModal}
                                          curr_client_id={curr_client_id} />
                                        ) : (
                                        <CreditNoteTables
                                          data={creditNoteData}
                                          loading={creditNoteLoading}
                                          totalRows={creditNoteTotalRows}
                                          page={creditNotePage}
                                          setPage={setCreditNotePage}
                                          limit={creditNoteLimit}
                                          setLimit={setCreditNoteLimit}
                                          fetchCreditNotes={fetchCreditNotes}
                                          curr_client_id={curr_client_id}
                                          openDeleteCreditNoteModal={openDeleteCreditNoteModal}
                                        />
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* <!--Create Invoice Modal Start--> */}
                            <CreateInvoiceModal
                            showModal={showAddInvoiceModal}
                            setShowModal={setShowAddInvoiceModal}
                            fetchInvoices={fetchInvoices}
                            limit={limit}
                            page={page}
                            _client_id={curr_client_id} />
                            {/* <!--Create Invoice Modal End--> */}


                            {/* <!--Delete Invoice Modal Start--> */}
                            <DeleteInvoiceModal
                            showModal={showDeleteInvoiceModal}
                            setShowModal={setShowDeleteInvoiceModal}
                            invoiceData={invoice_data}
                            modalKey={modalKey}
                            fetchInvoices={fetchInvoices}
                            limit={limit}
                            page={page}  />
                            {/* <!--Delete Invoice Modal End--> */}

                            <CreateCreditNoteModal
                            showModal={showAddCreditNoteModal}
                            setShowModal={setShowAddCreditNoteModal}
                            fetchCreditNotes={fetchCreditNotes}
                            limit={creditNoteLimit}
                            page={creditNotePage}
                            _client_id={curr_client_id} />

                            <DeleteCreditNoteModal
                            showModal={showDeleteCreditNoteModal}
                            setShowModal={setShowDeleteCreditNoteModal}
                            creditNoteData={credit_note_row}
                            modalKey={modalKey}
                            fetchCreditNotes={fetchCreditNotes}
                            limit={creditNoteLimit}
                            page={creditNotePage}
                            curr_client_id={curr_client_id} />

                        </div>
                    </div>
                    <div className="row"></div>
                    {/* <!--End::row-1 --> */}
                </div>
            </div>
            <Helmet></Helmet>
        </AdminLayout>
        ) : ( <Error403/>)}
    </>
   )
}
export default Invoices